var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskMaintenance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.372 2.368a5.635 5.635 0 0 0-7.166 7.528L2.602 18.5a2.045 2.045 0 0 0 0 2.898 2.045 2.045 0 0 0 2.898 0l8.603-8.604a5.633 5.633 0 0 0 7.528-7.167l-2.91 2.91a2.3 2.3 0 0 1-3.26 0 2.3 2.3 0 0 1 0-3.26l2.91-2.91z"
})));
export default SvgTaskMaintenance;